module.exports = "<div class=\"\">\n\t<dynamic-form [questions]=\"questions\" (submitted)=\"submit($event)\" #dynForm></dynamic-form>\n\n</div>\n"